import { useEffect, useState } from 'react'
import classes from './AgoraComponent.module.scss'
import { ref, onValue, off, update, get } from 'firebase/database'
import {database} from 'utils/firebase'
import { IoMic } from 'react-icons/io5'
import { BsCameraVideoFill } from 'react-icons/bs'
import { FcEndCall } from 'react-icons/fc'
import { BsMicMute } from 'react-icons/bs'
import { IoVideocamOffOutline } from 'react-icons/io5'
import { useDispatch, useSelector } from 'react-redux'
import {
  callNotificationVOIP,
  customCloudMessage,
} from 'MentalHealth/pages/ActiveChats/apis'
import AgoraSingleton from './AgoraSingleton'
// import useAgoraUsers from 'hooks/useAgora'
import { actions as manageCallActions } from 'slices/manageCall.slice'

let callLogsRef = null

const Controls = (props) => {
  // const { isCameraOff, isMicMuted } = useAgoraUsers()
  const { manageCallData, callJoiningStatus, isMicMuted, isCameraOff } =
    useSelector((state) => state.callData)
  const { patientProfile } = useSelector((state) => state.mentalHealth)
  const [callStatus, setCallStatus] = useState(null)
  const dispatch = useDispatch()
  const agoraInstance = AgoraSingleton.getInstance()
  const db = database

  const { track, tracks, setStart, client, type, id } = props

  useEffect(() => {
    console.log("callJoiningStatus ", callJoiningStatus)
  },[callJoiningStatus]);


  useEffect(() => {
    if(track)
    dispatch(manageCallActions.addLocalTracks([track]))
  else if(tracks)
    dispatch(manageCallActions.addLocalTracks(tracks))

  },[]);

  const setCallJoiningStatus = (status) => {
    dispatch(manageCallActions.closeTracks())
    dispatch(manageCallActions.setCallJoiningStatus(status))
  }

  const leaveChannel = async (status) => {
    if(manageCallData?.engageCall){
      console.log("Agorraaa leaveChannel")

      try {
        const obj = {
          engageCall: false,
        }
        dispatch(manageCallActions.manageCall(obj))
        console.log('leave channel', id)
        // client.removeAllListeners()
        // await client.leave()
        // if (type === 'audioCall') {
        //   track.close()
        // } else {
        //   tracks[1].close()
        //   tracks[0].close()
        // }
  
        let updates = {}
        // setStart(false)
        //setInCall(false)
        agoraInstance.handleEndCall(true, setCallJoiningStatus)
        const isFromPatient = status
        try {
          if(isFromPatient){
            let notificationPayload = {
              notificationToken: patientProfile?.notificationToken, // patient token
              data: {
                ReminderType:
                  type === 'audioCall' ? 'audioCallEnd' : 'videoCallEnd',
              },
            }
            let voipNotificationPayload = {
              production: process.env.NODE_ENV !== 'development',
              token: patientProfile?.voipToken,
              payload: {
                reminderType:
                  type === 'audioCall' ? 'audioCallEnd' : 'videoCallEnd',
              },
            }

            const callLogsStatusRef = ref(db, `callLogs/${id}/status`)
            const callLogsSnap = await get(callLogsStatusRef)

            if (
              callLogsSnap.val() === 'initiated' ||
              callLogsSnap.val() === 'call_ringing'
            ) {
              if (
                patientProfile?.notificationToken &&
                (patientProfile?.platform).toLowerCase() === 'android' &&
                type
              ) {
                const notificationResponse = await customCloudMessage(
                  notificationPayload,
                )
              }
              if (
                patientProfile?.voipToken &&
                (patientProfile?.platform).toLowerCase() === 'ios' &&
                type
              ) {
                const voipNotificationResponse = await callNotificationVOIP(
                  voipNotificationPayload,
                )
              }
            }
          }
        } catch (e) {
          console.log('error ', e)
        }
        if (id) {
          console.log('in final id')
          updates[`/callLogs/${id}/hostStatus`] = 'unavailable'
          if (!status) updates[`/callLogs/${id}/status`] = 'doctor_ended'
          if (!status)
            updates[`/callLogs/${id}/events/${Date.now()}`] = 'doctor_ended'
          await update(ref(db), updates)
        }
      } catch (e) {
        console.log('error ', e)
      }
    }
  }
  useEffect(() => {
    if (callLogsRef) {
      off(callLogsRef, 'value')
      callLogsRef = null
    }
    if (id) {
      const callLogsRefPath = ref(db, `callLogs/${id}/status`)
      callLogsRef = callLogsRefPath

      onValue(callLogsRefPath, (callLogsStatus) => {
        const status = callLogsStatus.val()
        if(status !== callStatus){
          setCallStatus(status)
          if (
            // status === 'patient_ended' ||
            // status === 'patient_declined' ||
            status === 'doctor_ended'
          ) {
            // leaveChannel('status')
          }
          console.log("callLogsReffff ", {status, callStatus})
          if ((status === 'patient_ended' || status === 'patient_declined') && !callStatus ) {
            leaveChannel(status)
          }
        }
      })
    }
  }, [id])

   // toggleMicMute = async () => {
  //   if (type === 'videoCall') {
  //     if (this.tracks && this.tracks[0]) {
  //       this.isMicMuted = !this.isMicMuted // Toggle mic mute state
  //       await this.tracks[0].setEnabled(!this.isMicMuted) // Enable/disable mic
  //       this.notifyObservers('isMicMuted', this.isMicMuted) // Notify observers of the change
  //     }
  //   }
  //   if (type === 'audioCall') {
  //     if (this.tracks) {
  //       this.isMicMuted = !this.isMicMuted // Toggle mic mute state
  //       await this.tracks.setEnabled(!this.isMicMuted) // Enable/disable mic
  //       this.notifyObservers('isMicMuted', this.isMicMuted) // Notify observers of the change
  //     }
  //   }
  // }

  // toggleCamera = async () => {
  //   if (this.tracks && this.tracks[1]) {
  //     this.isCameraOff = !this.isCameraOff // Toggle camera state
  //     await this.tracks[1].setEnabled(!this.isCameraOff) // Enable/disable camera
  //     this.notifyObservers('isCameraOff', this.isCameraOff) // Notify observers of the change
  //   }
  // }

  const toggleCamera = async () => {
    dispatch(manageCallActions.setMuteCamera(!isCameraOff))
  }
  const toggleMicMute = async () => {
    dispatch(manageCallActions.setMuteMic(!isMicMuted))
  }
  
  if (type === 'audioCall') {
    return (
      <div className={classes.buttons}>
        {!isMicMuted ? (
          <IoMic
            color="white"
            className={classes.button}
            onClick={toggleMicMute}
          />
        ) : (
          <BsMicMute
            color="white"
            className={classes.button}
            onClick={toggleMicMute}
          />
        )}
        <FcEndCall
          color="white"
          className={classes.button}
          onClick={() => leaveChannel()}
        />
      </div>
    )
  }

  return (
    <div className={classes.buttons}>
      {!isMicMuted ? (
        <IoMic
          color="white"
          className={classes.button}
          onClick={toggleMicMute}
        />
      ) : (
        <BsMicMute
          color="white"
          className={classes.button}
          onClick={toggleMicMute}
        />
      )}

      {!isCameraOff ? (
        <BsCameraVideoFill
          color="white"
          className={classes.button}
          onClick={toggleCamera}
        />
      ) : (
        <IoVideocamOffOutline
          color="white"
          className={classes.button}
          onClick={toggleCamera}
        />
      )}

      <FcEndCall
        color="white"
        className={classes.button}
        onClick={() => leaveChannel()}
      />
    </div>
  )
}

export default Controls
